import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'wtv', pathMatch: 'full' },
  {
    path: 'wtv',
    loadChildren: () => import('./wtv/wtv.module').then(m => m.WtvModule)
  },






];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
